import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const ADMIN_INITIAL: any = {
  feedback: [],
  isLoading: false,
};

const adminSlice = createSlice({
  name: "admin",
  initialState: {
    ...ADMIN_INITIAL,
  },
  reducers: {
    ADMIN_UPDATE: (
      state,
      action: PayloadAction<{
        data?: any;
        prop?: string;
        value?: string | Date;
      }>,
    ) => {
      return (state = {
        ...state,
        ...(action.payload.data ? action.payload.data : null),
        ...(action.payload.prop ? { [action.payload.prop]: action.payload.value } : null),
      });
    },
  },
});

const { ADMIN_UPDATE } = adminSlice.actions;

export { adminSlice, ADMIN_INITIAL, ADMIN_UPDATE };
